import React from "react";
import {
  SideBarContainer,
  Icon,
  CloseIcon,
  SideBarWrapper,
  SideBarMenu,
  SideBarLink,
} from "./SideBarElements";
import { Link } from "react-router-dom";
const SideBar = ({ isOpen, toogle }) => { 
  return (
    <SideBarContainer isOpen={isOpen} onClick={toogle}>
      <Icon onClick={toogle}>
        <CloseIcon />
      </Icon>
      <SideBarWrapper>
        <SideBarMenu>
          <SideBarLink  to="Sobrenosotros" onClick={toogle} >
            Sobre Nosotros
          </SideBarLink>
          <SideBarLink  to="Categorias" onClick={toogle}>
            Categorias
          </SideBarLink>
          <SideBarLink  to="Direccion" onClick={toogle}>
            Direccion
          </SideBarLink>
           <SideBarLink  to="Contacto" onClick={toogle}>
            Contacto
          </SideBarLink>
          <SideBarLink  >
            <Link id="login" to="login">Login</Link>
          </SideBarLink>
        </SideBarMenu>
      </SideBarWrapper>
    </SideBarContainer>
  );
};
//SideBar es el el menu desplegable que vemos en dispositivos mobiles
export default SideBar;